module.exports = __webpack_public_path__ + "img/aibuy-null.53c9001b.png";